import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'approval-button',
  templateUrl: './approval-button.component.html',
  styleUrls: ['./approval-button.component.scss']
})
export class ApprovalButtonComponent implements OnInit {

  @Input() index = 0;
  @Input() disabledRejectBtn = false;
  @Input() options = { page: '' };
  @Input() isApproveLoading = false;
  @Input() display = "desktop";
  @Output('onApproveClicked') onApproveButtonOutput = new EventEmitter(); // tslint:disable-line
  @Output('onRejectClicked') onRejectButtonOutput = new EventEmitter(); // tslint:disable-line

  constructor() { }

  ngOnInit() {
  }

  onApproveButtonClicked() {
    this.onApproveButtonOutput.emit();
  }

  onRejectButtonClicked() {
    this.onRejectButtonOutput.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/approval-button/approval-button.component.ts